import * as React from "react";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import DefaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import EtotpForm, { ITotpFormProps } from "../forms/etotpPasswordForm";

export interface IEtotpWithApiProps extends ITotpFormProps{
  onClose?: () => void;
  securityImgObj: any;
}

const EtotpWithApi: React.FC<IEtotpWithApiProps> = (props) => {
  return (
    <div className="loginWithApi">
      <div className="loginWithApi_container etotploginWithApi_container">
        <div className="loginWithApi_head etotploginWithApi_head">
          <span>
            <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
          </span>
          <span>
            <i className="edel-icon-close" onClick={props.onClose}></i>
          </span>
        </div>

        <div className="loginWithApi_contant">
          <div className="loginWithApi_appInfo">
            <img
              src={
                props.securityImgObj.logo
                  ? appUrl.appIcon + props.securityImgObj.logo
                  : DefaultAppIcon
              }
              alt="app logo"
            />
            <h3>{props.securityImgObj.appNm}</h3>
          </div>
          <EtotpForm {...props} securityImgObj={props.securityImgObj.accTypes} />
        </div>
      </div>
    </div>
  );
};

export default EtotpWithApi;
